import { render, staticRenderFns } from "./ProductDataTableRow.vue?vue&type=template&id=4a24b346&"
import script from "./ProductDataTableRow.vue?vue&type=script&lang=js&"
export * from "./ProductDataTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports